const languageSelectionOptions: { [key: string]: string } = {
  en: 'English',
  fr: 'French',
};

export default languageSelectionOptions;
